import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import TransferPage from "./components/TransferPage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <GoogleReCaptchaProvider reCaptchaKey="6LeURtAsAAAAAPckV9-_968wZZzH9bqPMULqHe7J">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<TransferPage />} />
            <Route path="/:accessToken" element={<TransferPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </GoogleReCaptchaProvider>
    </div>
  );
}

export default App;
